<div
  class="container"
  [class.small]="isSmall()">
  <p>{{ (displayFn() ? (value() | pure: displayFn()) : value()) || noValueText() }}</p>
  @if (isEditable()) {
    <div>
      @if (isEditable()) {
        <button
          #overlayOrigin
          #trigger="cdkOverlayOrigin"
          cdkOverlayOrigin
          class="no-style"
          (click)="originClicked()">
          <mat-icon>edit</mat-icon>
          <ng-template
            cdk-connected-overlay
            [cdkConnectedOverlayDisableClose]="false"
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="isOverlayVisible"
            [cdkConnectedOverlayHasBackdrop]="true"
            (backdropClick)="toggleOverlay()">
            <div
              #overlay
              class="overlay-container">
              @if (infoHeader()) {
                <p class="bold">{{ infoHeader() }}</p>
              }
              @if (infoText()) {
                <p>{{ infoText() }}</p>
              }
              @if (choices()?.length || lazyLoadChoicesFn()) {
                @if (choicesWithSearch() || lazyLoadChoicesFn()) {
                  <coin-v2-dropdown
                    #choiceSearch="dropdownSearch"
                    [dataSource]="choices() || lazyLoadChoicesFn()"
                    [placeholder]="placeholder()"
                    [(ngModel)]="editValue">
                    @for (item of choiceSearch.results(); track item) {
                      <ng-template [coinValue]="item">{{ displayFn()(item) }}</ng-template>
                    }
                  </coin-v2-dropdown>
                } @else {
                  <coin-v2-dropdown
                    [placeholder]="placeholder()"
                    [(ngModel)]="editValue">
                    @for (item of choices(); track item) {
                      <ng-template [coinValue]="item">{{ displayFn()(item) }}</ng-template>
                    }
                  </coin-v2-dropdown>
                }
              }
              @if (!choices()?.length && !lazyLoadChoicesFn()) {
                @switch (inputType()) {
                  @case ('text') {
                    <coin-v2-text-input
                      [placeholder]="placeholder()"
                      [(ngModel)]="editValue" />
                  }
                  @case ('number') {
                    <coin-v2-number-input
                      [placeholder]="placeholder()"
                      [(ngModel)]="editValue" />
                  }
                }
              }
              <div class="action-row">
                <coin-v2-button
                  [type]="'secondary'"
                  [icon]="'close'"
                  [iconPos]="'right'"
                  [text]="'general.cancel' | translate"
                  (click)="cancelClicked()"></coin-v2-button>

                <coin-v2-button
                  [type]="'primary'"
                  [icon]="'save'"
                  [iconPos]="'right'"
                  [text]="'general.btnSave' | translate"
                  (click)="saveClicked()"></coin-v2-button>
              </div>
            </div>
          </ng-template>
        </button>
      }
    </div>
  }
</div>
